import { Form, Select } from "antd";
import { ReactNode } from "react";
import {
  MdDangerous,
  MdLocalFireDepartment,
  MdMedication,
  MdNoAdultContent,
  MdRecordVoiceOver,
  MdReportGmailerrorred,
  MdShield,
} from "react-icons/md";
import { useAtomValue } from "jotai";
import { useWatch } from "antd/es/form/Form";
import { masterAtom } from "../../../../atoms/masters.atom";
import { masterToOptions } from "../../../../utils/functions/misc/masterToOptions";
import {
  FieldGrid,
  RatingTile,
  Section,
} from "../../components/section-card.component";

const RATINGS: {
  name: string;
  label: string;
  hint: string;
  icon: ReactNode;
  master:
    | "language_ratings"
    | "violence_ratings"
    | "hateful_ratings"
    | "adult_content_ratings"
    | "drugs_ratings"
    | "harmful_ratings";
}[] = [
  {
    name: "language_rating",
    label: "Language",
    hint: "Profanity, slang and tone.",
    icon: <MdRecordVoiceOver />,
    master: "language_ratings",
  },
  {
    name: "violence_rating",
    label: "Violence",
    hint: "Physical violence and intensity.",
    icon: <MdLocalFireDepartment />,
    master: "violence_ratings",
  },
  {
    name: "hateful_rating",
    label: "Hateful & Derogatory",
    hint: "Discriminatory or offensive content.",
    icon: <MdReportGmailerrorred />,
    master: "hateful_ratings",
  },
  {
    name: "adult_content_rating",
    label: "Adult Content",
    hint: "Sexual themes, nudity, intimacy.",
    icon: <MdNoAdultContent />,
    master: "adult_content_ratings",
  },
  {
    name: "drug_rating",
    label: "Drugs",
    hint: "Substance use and references.",
    icon: <MdMedication />,
    master: "drugs_ratings",
  },
  {
    name: "harmful_rating",
    label: "Harmful Acts",
    hint: "Dangerous behaviour viewers might imitate.",
    icon: <MdDangerous />,
    master: "harmful_ratings",
  },
];

export const StepThree = ({ visible = true }: { visible?: boolean }) => {
  const master = useAtomValue(masterAtom);
  const values = useWatch([]) ?? {};

  return (
    <div style={{ display: visible ? "block" : "none", width: "100%" }}>
      <Section
        icon={<MdShield />}
        title="Censor Ratings"
        subtitle="Self-rate your film across content categories so viewers know what to expect before they press play."
      >
        <FieldGrid $cols={3}>
          {RATINGS.map((rating) => (
            <RatingTile
              key={rating.name}
              icon={rating.icon}
              title={rating.label}
              hint={rating.hint}
              filled={!!values[rating.name]}
            >
              <Form.Item
                name={rating.name}
                rules={[{ required: true }]}
                style={{ marginBottom: 0 }}
              >
                <Select
                  size="large"
                  showSearch
                  options={masterToOptions(rating.master, master)}
                  placeholder="Select rating"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </RatingTile>
          ))}
        </FieldGrid>
      </Section>
    </div>
  );
};
